import { Tree as AntdTree } from "antd"
import PropTypes from "prop-types"
import { debounce } from "lodash"
import { useCallback, useEffect, useMemo, useState } from "react"

const Tree = ({
  checkedKeys,
  onCheck,
  debounceDelay = 400,
  treeData,
  checkable = true,
  disabled = false,
  checkStrictly = false,
  onBeforeCheck,
  ...props
}) => {
  const [localCheckedKeys, setLocalCheckedKeys] = useState([])

  useEffect(() => {
    setLocalCheckedKeys(checkedKeys)
  }, [checkedKeys])

  const debouncedOnCheck = useMemo(() => {
    return debounceDelay ? debounce(onCheck, debounceDelay) : onCheck
  }, [debounceDelay, onCheck])

  const handleCheck = (checkedObj, info) => {
    if (onBeforeCheck && !onBeforeCheck(checkedObj, info)) return
    setLocalCheckedKeys(checkedObj)
    debouncedOnCheck?.(checkedObj, info)
  }

  return (
    <AntdTree
      key={props?.key}
      treeData={treeData}
      checkedKeys={localCheckedKeys}
      onCheck={handleCheck}
      disabled={disabled}
      checkable={checkable}
      checkStrictly={checkStrictly}
      {...props}
    />
  )
}

Tree.propTypes = {
  treeData: PropTypes.array.isRequired,
  checkedKeys: PropTypes.array.isRequired,
  onCheck: PropTypes.func.isRequired,
  debounceDelay: PropTypes.number,
  onBeforeCheck: PropTypes.func,
}

export default Tree
